<script setup lang="ts">
import {
  PaginationEllipsis,
  PaginationList,
  PaginationListItem,
  PaginationNext,
  PaginationPrev,
  PaginationRoot
} from 'reka-ui'

const props = defineProps<{
  total: number
  limit?: number
}>()
</script>

<template>
  <PaginationRoot
    :total="props.total"
    :items-per-page="props.limit ?? 10"
    show-edges
    :default-page="1"
  >
    <PaginationList
      v-slot="{ items }"
      class="inline-flex items-center gap-1 mx-auto"
    >
      <PaginationPrev
        class="w-11 h-11 cursor-pointer flex items-center justify-center bg-secondary-container transition disabled:opacity-50 rounded-full"
      >
        <Icon name="material-symbols:arrow-back" size="20px" />
      </PaginationPrev>
      <div class="bg-secondary-container rounded-full p-1.5 flex gap-1">
        <template v-for="(page, index) in items">
          <PaginationListItem
            v-if="page.type === 'page'"
            :key="index"
            as="div"
            class="w-8 h-8 cursor-pointer rounded-full data-[selected]:!bg-primary data-[selected]:shadow-sm data-[selected]:text-on-primary relative"
            :value="page.value"
            :to="page.value"
          >
            <slot name="item" :value="page.value">
              {{ page.value }}
            </slot>
          </PaginationListItem>
          <PaginationEllipsis
            v-else
            :key="page.type"
            :index="index"
            class="w-8 h-8 flex items-center justify-center"
          >
            &#8230;
          </PaginationEllipsis>
        </template>
      </div>
      <PaginationNext
        class="w-11 h-11 cursor-pointer flex items-center justify-center bg-secondary-container transition disabled:opacity-50 rounded-full"
      >
        <Icon name="material-symbols:arrow-forward" size="20px" />
      </PaginationNext>
    </PaginationList>
  </PaginationRoot>
</template>
